// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"08b90943","64":"bf99513c","75":"a0090e1a","277":"4ed0eb4b","306":"d8081adc","315":"70bf4647","355":"27e3afa8","364":"05653ef5","425":"239de3ab","452":"50739dcd","482":"793299de"}[chunkId] + ".chunk.js";
};